<template>
  <div class="site-menu-wrap">
    <el-scrollbar :wrap-style="'overflow-x:hidden;'">
      <div :id="`menu-${menuItem.menuId}`" v-for="(menuItem,menuIndex) in userTopMenu" :key="menuIndex" class="menu-item" >
        <router-link  tag="div" @click.native="menuClickHandle(menuIndex)" :to="menuItem.target !== 'blank' ? menuItem.url : ''" class="menu-item-wrap">
          <div class="item-icon-wrap">
            <i v-if=" menuItem.children.length > 0" class="el-icon-plus oprate"></i>
            <i :class="menuItem.iconClassName"></i>
          </div>
          <div class="item-title-wrap">
            <span class="item-link" v-if="menuItem.target === 'blank'" @click="enter(menuItem.url)" rel="noopener noreferrer">{{menuItem.menuText}}</span>
            <li v-else class="item-link">{{menuItem.menuText}}</li>
          </div>
        </router-link>
        <transition name="slide-fade">
          <div v-if="subMenuStates[menuIndex].isShow"  class="sub-menu-wrap">
            <div v-for="(subMenuItem,subMenuIndex) in menuItem.children" :key="subMenuIndex" class="sub-menu">
              <div class="sub-menu-item-wrap">
                <div class="sub-item-icon-wrap">
                  <i :class="subMenuItem.iconClassName"></i>
                </div>
                <div class="sub-item-title-wrap">
                  <span class="sub-item-link" v-if="subMenuItem.target === 'blank'" @click="enter(subMenuItem.url)" rel="noopener noreferrer">
                    {{subMenuItem.menuText}}
                  </span>
                  <router-link v-else class="sub-item-link" tag="li" :to="subMenuItem.url">{{subMenuItem.menuText}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import common from '@/util/common'
export default {
  name: 'SiteMenu',
  data () {
    return {
      // userTopMenu: [],
      subMenuStates: [],
      isShow: false
    }
  },
  props: {
    userInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    userTopMenu () {
      return this.$store.getters.userMenus
    }
  },
  methods: {
    menuClickHandle (menuItemIndex) {
      let menuItem = this.userTopMenu[menuItemIndex]
      let menuDom = document.getElementById(`menu-${menuItem.menuId}`)
      let menuDomAll = document.getElementsByClassName('menu-item')
      for (let menuDomTmp of menuDomAll) {
        menuDomTmp.className = 'menu-item'
        for (let i = 0; i < this.subMenuStates.length; i++) {
          this.subMenuStates[i].isShow = false
        }
      }
      menuDom.className = 'menu-item active-menu'
      if (menuItem.children.length > 0) {
        this.subMenuStates[menuItemIndex].isShow = true
      }
    },
    enter(url) {
      window.open(url)
    },
    setMenuClass () {
      this.userTopMenu.forEach((menu, index) => {
        if (this.$route.meta.topMenu === menu.menuText) {
          this.$nextTick(() => {
            let menuDom = document.getElementById(`menu-${menu.menuId}`)
            menuDom.className = 'menu-item active-menu'
            this.subMenuStates[index].isShow = true
          })
        }
      })
    }
  },
  created () {
    console.log(sessionStorage.getItem('user_info'))
    console.log(this.$store.getters.userMenus, this.$store, this.$store.getters)
    if (this.$route.path === '/exam') {
      this.$router.push(this.$store.getters.userMenus[0].url, () => {
        this.setMenuClass()
      })
    }
    this.$store.getters.userMenus.forEach((menu, index) => {
      if (index === 0) {
        this.subMenuStates.push({
          isShow: true
        })
      } else {
        this.subMenuStates.push({
          isShow: false
        })
      }
    })
  },
  mounted () {
    this.setMenuClass()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
$width: 162px;
.site-menu-wrap {
  width: $width;
  background: #469046;
  height: calc(100vh - 350px);
  display: flex;
  flex-direction: column;
  position: relative;

  /deep/ .el-scrollbar {
    height: 100%;
  }
  /deep/ .el-scrollbar__thumb {
    background-color: rgba(234, 236, 241, 0);
  }
  .menu-item{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: $width - 10px;
    cursor: pointer;
    color: white;
    border-left: 8px solid #469046;
    border-top: 1px solid #469046;
    border-right: 1px solid #469046;
    border-bottom: 1px solid #469046;
    background: #469046;
    &:hover{
      border-left: 8px solid #00B22D;
      border-top: 1px solid #00B22D;
      border-right: 1px solid #00B22D;
      border-bottom: 1px solid #00B22D;
      background: #0F7B0F;
    }
    .menu-item-wrap{
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .item-icon-wrap{
      padding-left: 20px;
      display: flex;
      align-items: center;
      i{
        font-size: 24px;
      }
      .oprate{
        font-size: 12px;
        margin-left: -15px;
        margin-right: 5px;
      }
    }
    .item-title-wrap{
      width: 100%;
      padding-left: 10px;
      .item-link{
        font-size: 18px;
        // font-weight: 600;
        list-style-type: none;
        color: #fff;
        text-decoration: none;
      }
    }
  }
  .active-menu{
    border-left: 8px solid #00B22D;
    border-top: 1px solid #00B22D;
    border-right: 1px solid #00B22D;
    border-bottom: 1px solid #00B22D;
    background: #0F7B0F;
  }
  .sub-menu-wrap{
    width: 100%;
    display: flex;
    flex-direction: column;
    .sub-menu{
      width: 107%;
      margin-left: -10px;
      background: #0E6B0E;
      display: flex;
      flex-direction: column;
      align-items: center;
      .sub-menu-item-wrap{
        height: 50px;
        color: $color-off;
        width: 85%;
        display: flex;
        justify-content: center;
        align-items: center;
        a{
          color: inherit;
        }
        .sub-item-icon-wrap{
          margin-left: 30px;
          i{
            font-size: 24px;
          }
        }
        .sub-item-title-wrap{
          width: 100%;
          padding-left: 10px;
          .sub-item-link{
            font-size: 16px;
            // font-weight: 600;
            list-style-type: none;
            text-decoration: none;
          }
        }
        &:nth-child(n+2)
        {
          border-top:1px solid #0F7A0F;
        }
        &:hover{
          color: white;
        }
      }
    }
  }
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s ease;
}
.slide-fade-enter
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.slide-fade-leave-to{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/home/SiteMenu.vue